<template>
  <el-dialog :title="content.title" :visible.sync="visible" :close-on-click-modal="false" width="30%">
    <el-form ref="form" label-position="top" label-width="150px" :model="form" :rules="fields.validation">
      <el-form-item prop="title" label="Titre">
        <el-input placeholder="Saisissez le titre de votre tâche" v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item prop="description" label="Description">
        <el-input type="textarea" autosize placeholder="Saisissez la description de votre tâche" v-model="form.description"></el-input>
      </el-form-item>
      <el-form-item prop="task_list" label="Session de travail">
        <el-select v-model="selectedTaskList" class="form-control">
          <el-option v-for="tasklist in tasklists" :key="tasklist.id" :label="tasklist.name" :value="tasklist.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="this.form.id !== null" type="danger" :plain="true" v-on:click.native="visible = false" v-delete:task="this.form"
                 class="pull-left">Supprimer</el-button>
      <el-button v-on:click="visible = false">Annuler</el-button>
      <el-button :type="content.button_type" v-on:click="submit()">{{ content.button }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'task-modal',
    data () {
      return {
        visible: false,
        content: {
          title: '',
          button: '',
          button_type: ''
        },
        fields: {
          validation: {
            title: [
              {required: true, message: 'Vous devez au moins saisir un titre'}
            ]
          }
        },
        form: {
          id: null,
          title: '',
          description: ''
        },
        selectedTaskList: null
      }
    },
    computed: {
      tasklists () {
        return this.$store.getters['task_lists/owned']
      }
    },
    watch: {
      visible (visible) {
        if (!visible) {
          this.reset()
        }
      }
    },
    mounted () {
      let self = this

      this.$model.task.on('create', ({item}) => {
        self.content.title = 'Création d\'une tâche'
        self.content.button = 'Créer la tâche'
        self.content.button_type = 'success'

        self.load(item)
        self.selectedTaskList = this.$store.getters['task_lists/current'].id

        self.visible = true
      })

      this.$model.task.on('edit', ({item}) => {
        self.content.title = 'Modification d\'une tâche'
        self.content.button = 'Modifier la tâche'
        self.content.button_type = 'warning'

        self.load(item)
        self.selectedTaskList = this.$store.getters['task_lists/current'].id

        self.visible = true
      })

      this.$model.task.on('delete', ({item}) => {
        // Is done directly on the list
      })
    },
    methods: {
      reset () {
        this.form = this.$options.data.apply(this).form
        this.$refs['form'].resetFields()
      },
      load (item) {
        if (item) {
          if (item.id !== null) this.form.id = item.id
          if (item.title) this.form.title = item.title
          if (item.description) this.form.description = item.description
        }
      },
      submit () {
        let self = this

        this.$refs['form'].validate((valid) => {
          if (valid) {
            let p

            let task = {
              component: 'CustomTask',
              payload: _.omit(self.form, 'id')
            }

            if (this.form.id === null) {
              p = self.$store.dispatch('task_lists/createTask', {taskListId: self.selectedTaskList, task})
            } else {
              p = self.$store.dispatch('task_lists/updateTask', {taskListId: self.selectedTaskList, offset: self.form.id, task})
            }

            p.then(() => {
              self.visible = false
            })
          } else {
            self.$message.error('Impossible de valider le formulaire. Merci de vérifier les valeurs saisies')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TaskModal.vue?6911c21f